import { __assign } from "tslib";
import React, { Suspense } from 'react';
import Skeletons from '../infoui-components/components/Skeleton';
import { themes } from '../ThemeOptions';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapAttachment = React.lazy(function () {
    return import('./BTAttachment');
});
var bootStrapAttachment = function (props) {
    return React.createElement(BootStrapAttachment, __assign({}, props));
};
var Attachment = function (props) {
    var componentToDisplay = bootStrapAttachment(props);
    // switch (props.ioTheme.uiLibrary) {
    //     case 'materialui':
    //         componentToDisplay = bootStrapAttachment(props);
    //         break;
    //     default:
    //         componentToDisplay = bootStrapAttachment(props);
    //         break;
    // }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
Attachment.defaultProps = {
    styleName: 'primary',
    name: 'Attachment',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default Attachment;
//# sourceMappingURL=Attachment.js.map